var _defs, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReferences(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.32 30.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fcb116;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.49,25.81l1.29-1,1.29,1-.49-1.59,1.29-1H24.28l-.51-1.56-.51,1.56H21.69l1.29,1Zm5.75-2.05a4.46,4.46,0,1,0-7.8,2.94V31l3.34-1.11L27.12,31v-4.3A4.43,4.43,0,0,0,28.23,23.75Zm-4.45-3.34a3.34,3.34,0,1,1-3.34,3.34A3.34,3.34,0,0,1,23.78,20.41Zm0,8.35-2.23.57V27.61a4.43,4.43,0,0,0,4.45,0v1.73Z",
    transform: "translate(-11.62 -5.81)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.82,5.81H14.66a3,3,0,0,0-3,3l0,24.32a3,3,0,0,0,3,3H32.9a3,3,0,0,0,3-3V14.93ZM14.66,33.17V8.85H25.3v7.6h7.6V33.17Z",
    transform: "translate(-11.62 -5.81)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferences);
export default __webpack_public_path__ + "static/media/references.74459979d6727053312f18edf0e289d7.svg";
export { ForwardRef as ReactComponent };